import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatMessage } from '../../ai-counselor.model';
import { SafeMarkdownDirective } from '../../../../../../shared/directives/safe-markdown.directive';

@Component({
  selector: 'mindbase-message-bubble',
  standalone: true,
  imports: [CommonModule, SafeMarkdownDirective],
  templateUrl: './message-bubble.component.html',
  styleUrl: './message-bubble.component.scss'
})
export class MessageBubbleComponent {
  @Input() message!: ChatMessage;
  @Input() botAvatarUrl  = '';
  @Input() userAvatarUrl = '';
}
